import api from 'src/config/api';
import { getJsonResponse } from 'src/utils/ApiUtils';
import { CollectionResponse } from 'src/interfaces/api/api';
import { EmployeeEvent } from '../../interfaces/api/Gaming';
import useAuth from './useAuth';

const useGamingFeed = () => {
  const { fetch } = useAuth();

  const getEmployeeEvents = async (
    employeeId: string,
    page: number,
    limit: number
  ): Promise<CollectionResponse<EmployeeEvent>> => {
    const { endpoint, ...options } = api.gaming.getEmployeeEvents(employeeId, page, limit);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<EmployeeEvent>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return { getEmployeeEvents };
};

export default useGamingFeed;
